/**
 * Client-only boot side effects ported from flowstate-automate main.tsx.
 */
import { useEffect } from "react";
import {
  injectSupabaseClient,
  initializeMyceliumProtocol,
  setMyceliumTransport,
  PgmqMyceliumTransport,
  type PgmqSupabaseClient,
} from "@flowstate/core";
import { supabase } from "@/integrations/supabase/client";
import { registerAllGoogleServices } from "@/services/integrations/google-services-registry";
import { crmSalesEventBridge } from "@/services/integrations/crm-sales-event-bridge.service";
import { logger } from "@/lib/logger";

export function ClientBoot() {
  useEffect(() => {
    injectSupabaseClient(supabase);

    crmSalesEventBridge
      .initialize()
      .then(() => {
        logger.info("CRM-Sales Event Bridge initialized with mycelium protocol");
      })
      .catch((error) => {
        logger.error("Failed to initialize CRM-Sales Event Bridge", { error });
      });

    registerAllGoogleServices();
    logger.info("All Google services registered and initialized");

    setMyceliumTransport(
      new PgmqMyceliumTransport({
        supabaseClient: supabase as unknown as PgmqSupabaseClient,
        useRouterFunction: true,
      }),
      "pgmq",
    );

    initializeMyceliumProtocol().catch((error) => {
      logger.error("Failed to initialize Mycelium Protocol", { error });
    });
  }, []);

  return null;
}
